module.exports = __webpack_public_path__ + "img/7s.8057bc9c.png";